import { useQuery } from '@apollo/client';
import { useContext, useMemo } from 'react';
import { ContentLibrary } from '.';
import { ContentLibraryContext, ContentLibraryContextValue } from './context';
import { GET_TASK_CONTENT_LIBRARY } from './queries';
import {
  ApiContentLibraryResponse,
  ApiContentLibraryVars,
  ContentLibraryResponseData,
  DEFAULT_CONTENT_LIBRARY_LIMIT
} from './types';

export function useLoadTaskContentLibrary(question?: string): ContentLibraryResponseData {
  const query = useQuery<ApiContentLibraryResponse, ApiContentLibraryVars>(GET_TASK_CONTENT_LIBRARY, {
    variables: { question: question ?? '', offset: 0, limit: DEFAULT_CONTENT_LIBRARY_LIMIT },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: !question
  });

  return useMemo(
    () => ({
      ...query,
      data: query.data?.getRowsFromSimilarQuestionsTenjin
        ? new ContentLibrary(query.data?.getRowsFromSimilarQuestionsTenjin)
        : undefined,
      loading:
        (query.loading || query === undefined || query.networkStatus === 4 || query.networkStatus === 2) &&
        query.networkStatus !== 3,
      fetchingMore: query.networkStatus === 3
    }),
    [query]
  );
}

export function useContentLibrary(): ContentLibraryContextValue {
  const state = useContext(ContentLibraryContext);
  if (!state) {
    throw new Error('not in ContentLibraryContext provider');
  }

  return state;
}
